import { render, staticRenderFns } from "./OtherServiceDescription.vue?vue&type=template&id=852e3cf6&"
import script from "./OtherServiceDescription.vue?vue&type=script&lang=js&"
export * from "./OtherServiceDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports